import { t } from "i18next";
import React from "react";
import { Link } from "react-router-dom";

import "./BetHistoryNav.scss";

interface IBetHistoryNav {
  page: string;
}

const BetHistoryNav = ({ page }: IBetHistoryNav) => {
  return (
    <div className="hdr-navigation-scrollable-bc">
      <div
        className="hdr-navigation-scrollable-content"
        data-scroll-lock-scrollable=""
      >
        <Link
          className={`hdr-navigation-link-bc ${
            page === "bets" ? "active" : ""
          }`}
          to={{
            search: "profile=open&account=history&page=bets",
          }}
        >
          {t("admin.All")}
          <i className="  count-blink-even " data-badge="" />
        </Link>
        <Link
          className={`hdr-navigation-link-bc ${
            page === "open-bets" ? "active" : ""
          }`}
          to={{
            search: "profile=open&account=history&page=open-bets",
          }}
        >
          {t("admin.Openbets")}
          <i className="  count-blink-even " data-badge="" />
        </Link>
        <Link
          className={`hdr-navigation-link-bc ${
            page === "gifted" ? "active" : ""
          }`}
          to={{
            search: "profile=open&account=history&page=gifted",
          }}
        >
          {t("admin.Giftedbets")}
          <i className="  count-blink-even " data-badge="" />
        </Link>
        <Link
          className={`hdr-navigation-link-bc ${
            page === "gifts" ? "active" : ""
          }`}
          to={{
            search: "profile=open&account=history&page=gifts",
          }}
        >
          {t("admin.Receivedgifts")}
          <i className="  count-blink-even " data-badge="" />
        </Link>
      </div>
    </div>
  );
};

export { BetHistoryNav };
